import React from 'react';
import {Popover,Icon} from 'antd';
import classnames from 'classnames';
import styles from './index.m.less';

const TipLabel = props => {
    const {label,content,colon,tips} = props;
    const labelCls = classnames({
        [styles.label]:true,
        [styles.colonLabel]:colon
    });
    return (
        <div className={styles.labelBox}>
            <span className={labelCls}>{label}</span>
            {content && (
                <Popover
                    placement="rightTop"
                    arrowPointAtCenter
                    content={content}
                >
                    <Icon className={styles.icon} style={{color:tips && '#F78900'}} type="info-circle" theme="filled" />
                </Popover>
            )}
            {tips && <span className={styles.tips}>{tips}</span>}
        </div>
    );
};

export default TipLabel;



// WEBPACK FOOTER //
// ./src/components/TipLabel/index.js